import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { DetailedInventoryItem, IGetInventoryItemResponseBody } from './types';

export const getInventoryItem = async (id: string): Promise<DetailedInventoryItem | null> => {
  try {
    const res = await fetch(`${API_URL}/recipes/${id}`);

    if (!res.ok) throw new Error(res.statusText);

    const { data }: IGetInventoryItemResponseBody = await res.json();

    if (!data) {
      return null;
    }

    if (Array.isArray(data)) {
      return data[0] ?? null;
    }

    return data;
  } catch (e) {
    throw new Error('Could not fetch inventory item', { cause: e });
  }
};
